module.exports = __webpack_public_path__ + "static/media/ва.19695950.mp3";